import { Link, Location, useLocation, useSearchParams } from "react-router";
import React from "react";
import { Button } from "@mindstonehq/ui";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import { BurgerMenuIcon } from "../icons";

export default function AnnotateMobileHeader({
  toggle,
  open,
}: {
  toggle: () => void;
  open: boolean;
}) {
  const location = useLocation();
  const gobackUrl = React.useMemo(() => {
    if (location.state?.back && location.state.back.pathname) {
      const backLocation = location.state.back as Location;
      return `${backLocation.pathname}${backLocation.search ? `${backLocation.search}` : ""}`;
    } else {
      return "/";
    }
  }, [location.state]);
  return (
    <div className="md:hidden sticky top-0 flex justify-between h-14 items-center px-4 py-2 bg-card w-full z-50 border-b border-border">
      <Button variant="ghost" asChild>
        <Link to={`${gobackUrl}`}>
          <ArrowLeftIcon className="h-6 w-6" />
        </Link>
      </Button>
      <Button onClick={toggle} variant="ghost">
        <BurgerMenuIcon isOpen={open} size={16} />
      </Button>
    </div>
  );
}
